import React, { useState } from "react";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";

const AepsSettlement = () => {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    bankName: "",
    status: "",
  });

  const [settlements, setSettlements] = useState([
    {
      id: "TXN12345",
      bank: "HDFC Bank",
      amount: 2500,
      status: "Success",
      date: "2025-08-15",
    },
    {
      id: "TXN12346",
      bank: "SBI Bank",
      amount: 1800,
      status: "Pending",
      date: "2025-08-16",
    },
  ]);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleFilter = (e) => {
    e.preventDefault();

  };

  return (

<>
<Seo />
<Header heading="AEPS Settlement Report" />
    <div className="p-2 bg-gray-100 min-h-screen">
      {/* Title */}
     

      {/* Filter Form */}
      <form
        onSubmit={handleFilter}
        className="grid md:grid-cols-4 gap-4 bg-white p-4 rounded-xl shadow-md mb-6"
      >
        <div>
          <label className="block text-sm font-medium text-gray-600">
            From Date
          </label>
          <input
            type="date"
            name="fromDate"
            value={filters.fromDate}
            onChange={handleChange}
            className="w-full mt-1 p-2 border rounded-md focus:ring focus:ring-blue-300"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-600">
            To Date
          </label>
          <input
            type="date"
            name="toDate"
            value={filters.toDate}
            onChange={handleChange}
            className="w-full mt-1 p-2 border rounded-md focus:ring focus:ring-blue-300"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-600">
            Bank Name
          </label>
          <input
            type="text"
            name="bankName"
            value={filters.bankName}
            onChange={handleChange}
            placeholder="Enter bank"
            className="w-full mt-1 p-2 border rounded-md focus:ring focus:ring-blue-300"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-600">
            Status
          </label>
          <select
            name="status"
            value={filters.status}
            onChange={handleChange}
            className="w-full mt-1 p-2 border rounded-md focus:ring focus:ring-blue-300"
          >
            <option value="">All</option>
            <option value="Success">Success</option>
            <option value="Pending">Pending</option>
            <option value="Failed">Failed</option>
          </select>
        </div>
        <div className="md:col-span-4 flex justify-end">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Apply Filter
          </button>
        </div>
      </form>

      {/* Settlement Table */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-200 text-gray-700">
            <tr>
              <th className="p-3">Txn ID</th>
              <th className="p-3">Bank Name</th>
              <th className="p-3">Amount</th>
              <th className="p-3">Status</th>
              <th className="p-3">Date</th>
            </tr>
          </thead>
          <tbody>
            {settlements.length > 0 ? (
              settlements.map((s, index) => (
                <tr
                  key={index}
                  className="border-b hover:bg-gray-50 transition"
                >
                  <td className="p-3 font-mono">{s.id}</td>
                  <td className="p-3">{s.bank}</td>
                  <td className="p-3 text-green-600 font-semibold">
                    ₹{s.amount}
                  </td>
                  <td
                    className={`p-3 font-medium ${
                      s.status === "Success"
                        ? "text-green-600"
                        : s.status === "Pending"
                        ? "text-yellow-600"
                        : "text-red-600"
                    }`}
                  >
                    {s.status}
                  </td>
                  <td className="p-3">{s.date}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="p-4 text-center text-gray-500">
                  No settlements found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    </>
  );
};

export default AepsSettlement;
